import { Loading } from './page-loading';
export * from './page-loading';
export default Loading;
